import { useNavigate, useRouteError } from 'react-router-dom'
import styled from 'styled-components'
import message_icon from 'src/assets/images/icon/icon-message.png'
import { Noto_body1_b16, Noto_body1_r16, Noto_body2_r14 } from 'src/styles/font/NotoSansKrFonts'
import React, { useEffect } from 'react'
import { gri } from 'src/service/utils'
import { captureError } from 'src/service/utils/sentry'
import { monitoredReplace } from 'src/service/utils/sentry/navigation'

const ErrorBoundaryPage = () => {
  const error = useRouteError()
  // if (error instanceof AxiosError) {
  // console.warn('error', error)
  const navigate = useNavigate()

  const pageBackHandler = () => {
    navigate(-1)
  }
  const pageReloadHandler = () => {
    window.location.reload()
  }

  useEffect(() => {
    if (!error) return
    if (!(error instanceof Error)) return

    captureError(error)
  }, [error])

  return (
    <ErrorBoundaryWrap>
      <ErrorContents>
        <ErrorMessageIcon src={message_icon} alt={'메시지 아이콘'} />
        <ErrorText>페이지를 찾을 수 없습니다.</ErrorText>
        <ErrorReloadButton onClick={pageReloadHandler}>새로고침</ErrorReloadButton>
        <ErrorPageBackButton onClick={pageBackHandler}>뒤로가기</ErrorPageBackButton>
        {window.location.href.includes('localhost') && (
          <LocalOnlyViewContainer>
            <p>로컬에서만 노출됩니다.</p>
            <button
              onClick={() =>
                monitoredReplace(
                  `${window.location.origin}/rop01/default/${gri()}/0`,
                  'handleMoveToDefaultJoinPage',
                )
              }
            >
              기본가입창 바로가기
            </button>
          </LocalOnlyViewContainer>
        )}
      </ErrorContents>
    </ErrorBoundaryWrap>
  )
}

export default ErrorBoundaryPage

const ErrorBoundaryWrap = styled.div`
  height: calc(var(--vh, 1vh) * 100);
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ErrorContents = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 320px;
  margin: 0 auto;
`

const ErrorMessageIcon = styled.img`
  width: 40px;
  height: 30px;
  margin: 0 auto;
`
const ErrorText = styled.p`
  ${Noto_body1_r16};
  margin-top: 28px;
  margin-bottom: 70px;
  text-align: center;
  color: var(--black-50);
`
const ErrorPageButton = styled.button`
  width: 260px;
  border-radius: 12px;

  ${Noto_body2_r14};
`
const ErrorReloadButton = styled(ErrorPageButton)`
  color: var(--black-60);
  border: 1px solid var(--black-10);
  height: 38px;
  margin-bottom: 10px;
`
const ErrorPageBackButton = styled(ErrorPageButton)`
  color: var(--black-30);
`

const LocalOnlyViewContainer = styled.section`
  margin-top: 50px;
  padding: 10px;
  border-radius: 20px;
  border: 2px dotted var(--brand-50);
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  text-align: center;
  ${Noto_body1_b16};
  > button {
    background-color: var(--black-30);
    border-radius: 20px;
    padding: 10px;
    color: var(--white);
  }
`
